import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Stack } from '@optimus-web/core';
import { Configure2FALayout } from '../Configure2FALayout';
import {
    Configure2FADeviceConfigContent,
    Configure2FADeviceConfigContentProps,
} from './Configure2FADeviceConfigContent';

export interface Configure2FADeviceConfigProps extends Configure2FADeviceConfigContentProps {
    onCancel: () => void;
    onSuccess: () => void;
}

export function Configure2FADeviceConfig({
    onCancel,
    onSuccess,
    authenticator,
    isPending,
}: Configure2FADeviceConfigProps) {
    return (
        <Configure2FALayout title={TextKey.AuthenticatorGetCodes}>
            <Stack spacing="300" vertical>
                <Configure2FADeviceConfigContent authenticator={authenticator} isPending={isPending} />

                <Stack spacing="100" distribution="space-between">
                    <Button onClick={onCancel} size="medium" type="submit">
                        <LocalizedText textKey={TextKey.GoBack} />
                    </Button>
                    <Button variant="primary" onClick={onSuccess} size="medium" type="submit">
                        <LocalizedText textKey={TextKey.Next} />
                    </Button>
                </Stack>
            </Stack>
        </Configure2FALayout>
    );
}
